var _style, _path, _polygon;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckboxSelectedLandingMcc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Checkbox Selected") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n      .Neutral4MCC{fill:#b1b1b1;}\r\n      .PrimaryBrandMCC{fill:#589acb;}\r\n    ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "Neutral4MCC",
    d: "M21.8,1c.7,0,1.2.5,1.2,1.2v19.6c0,.7-.5,1.2-1.2,1.2H2.2c-.7,0-1.2-.5-1.2-1.2V2.2c0-.7.5-1.2,1.2-1.2h19.6M21.8,0H2.2C1,0,0,1,0,2.2v19.6c0,1.2,1,2.2,2.2,2.2h19.6c1.2,0,2.2-1,2.2-2.2V2.2c0-1.2-1-2.2-2.2-2.2h0Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "PrimaryBrandMCC",
    points: "11.8 18.8 4.6 11.6 5.8 10.2 11.2 15.5 17.8 4.2 19.5 5.1 11.8 18.8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxSelectedLandingMcc);
export default __webpack_public_path__ + "static/media/checkbox_selected_landing-mcc.9238d36a6f3c3fb015b326764c5c53bb.svg";
export { ForwardRef as ReactComponent };